import React from "react";

class MonthButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            monthSelected: props.monthSelected,
            monthDescription: props.monthDescription,
            monthIndex: props.monthIndex,
            selected: props.selected,
            buttonBackground: undefined,
            buttonColor: "darkgray"
        };
    }

    componentDidMount() {
        this.changeStyleBySelection(this.state.selected);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.selected !== this.props.selected) {
            this.changeStyleBySelection(this.props.selected);
        }
    }

    onMonthClick = (monthIndex) => {
        const stateAfterClick = !this.state.selected;

        this.changeStyleBySelection(stateAfterClick);

        if (this.state.monthSelected) {
            this.state.monthSelected(monthIndex);
        }

        this.setState({ selected: !this.state.selected });
    };

    changeStyleBySelection(selected) {
        if (selected) {
            this.setState({
                buttonBackground: "#ff6666",
                buttonColor: "white"
            });
        } else {
            this.setState({
                buttonBackground: undefined,
                buttonColor: "darkgray"
            });
        }
    }

    render() {
        const buttonCss = {
            borderRadius: 26,
            borderWidth: "2px",
            borderStyle: "none",
            color: "darkgray",
            padding: 8,
            textAlign: "center",
            margin: 4,
            whiteSpace: "nowrap",
            height: "50px"
        };

        return (
            <div
                style={{ borderWidth: 0, background: "white" }}
                onClick={() => {
                    this.onMonthClick(this.state.monthIndex);
                }}
                key={this.state.monthIndex}
            >
                <div
                    style={Object.assign({}, buttonCss, {
                        backgroundColor: this.state.buttonBackground
                    })}
                >
                    <p style={{ color: this.state.buttonColor, fontSize: 20 }}>{this.state.monthDescription}</p>
                </div>
            </div>
        );
    }
}

export default MonthButton;
